import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {User} from '../../../models/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {MonitorUserTimeline} from '../../../models/monitor-user-timeline';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {DatePipe, Location} from '@angular/common';
import {MatPaginator, MatSelectChange, MatSort} from '@angular/material';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {Title} from '@angular/platform-browser';
import {TitleBroadcastService} from '../../../services/title-broadcast.service';
import {takeUntil} from 'rxjs/internal/operators';
import swal from 'sweetalert2';
import {Endpoints} from '../../../config/endpoints';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {UserTimeLinePoint} from '../../../models/user-time-line-point';
import {debounceTime} from 'rxjs/operators';
import * as L from 'leaflet';
import 'leaflet.gridlayer.googlemutant';
import {base_urls} from '../../../config/base_urls';
import {MarketService} from '../../../services/market-service';

@Component({
    selector: 'app-monitoring-user-timeline',
    templateUrl: './monitoring-user-timeline.component.html',
    styleUrls: ['./monitoring-user-timeline.component.scss']
})
export class MonitoringUserTimelineComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    timelineList: MonitorUserTimeline[] = [];
    filteredTimelineList: MonitorUserTimeline[] = [];
    listDataSource: UserTimeLinePoint[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    displayedColumns = ['SN', 'From', 'To', 'Address', 'Duration', 'Distance'];

    market = new Market();
    user = new User();
    headers = [];
    headerValues = [];
    exportData = [];
    progress: number;
    showProgressBar = false;
    waitForProgress = true;
    totalPages = 0;
    datePipe = new DatePipe('en-US');
    selectedTab = 'Map';
    lineColors: string[] = ['mediumseagreen', 'deepskyblue', 'gray', 'navy', 'yellow', 'orange', 'purple', 'cyan', 'magenta', 'lime'];
    imeiList: any[] = [];
    selectedImei: string;
    isCalenderOpen = false;
    tabList = ['Map', 'Timeline'];
    selectedRange: any = {startDate: null};
    calendarLocale: LocaleConfig;
    @ViewChild(DaterangepickerDirective) dateRangePicker: DaterangepickerDirective;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    userRank: number;
    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];
    marketIndex = 0;
    map: L.Map;
    polyLineLayer: L.LayerGroup = L.layerGroup();
    markerLayerGroup: L.LayerGroup = L.layerGroup();
    customStyle = [
        {
            'featureType': 'landscape',
            elementType: 'geometry',
            'stylers': [
                {'hue': '#37cb37'},
                {'saturation': -20},
                {'lightness': -8}
            ]
        }
    ];

    userId: number;
    userCode: string;


    dataSource: BaseDatasourceService<MonitorUserTimeline>;

    filters = {
        'userId': null,
        'date': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        fileType: null
    };
    userType = 'ORGANIZATION_USER';

    selectedMarketInfo: string;

    private _unsubscribeAll: Subject<any>;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.getLocationList();
        }
    }

    constructor(private route: ActivatedRoute, private service: BaseService, private auth: AuthService,
                private titleService: Title, private titleBroadcastService: TitleBroadcastService, private marketService: MarketService, private location: Location) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('User Timeline');
        this.loggedUser = auth.user;
        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();

        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
    }

    ngOnInit(): void {
        this.map = L.map('map').setView([23.8383283, 90.3759853], 7);
        L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: this.customStyle
        }).addTo(this.map);

        this.titleService.setTitle('Monitoring Team Tracking');

        this.userFilter.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.UserName.toLowerCase().indexOf(search.toLowerCase()) > -1
            ));
        });

        this.route.queryParams.subscribe(params => {
            if (params.userCode) {
                this._getUserList(params.userCode);
                this.userCode = params.userCode;
            } else {
                this._getUserList();
            }
            if (params.userId) {
                this.filters.userId = Number(params.userId);
                this.userId = Number(params.userId);
                this.getLocationList();
            }
        });

        this.loadInitialMarkets();
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });
    }

    dateChangeListener(pEvent: any): void {
        this.filters.date = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    openFilterModal(): void {
        const modal = document.getElementById('filterModal');
        modal.style.display = 'block';
    }

    closeFilterModal(): void {
        const modal = document.getElementById('filterModal');
        modal.style.display = 'none';
    }

    compareUsers(pUser1: number, pUser2: number): boolean {
        return pUser1 && pUser2 && pUser1 == pUser2;
    }

    loadInitialMarkets(): void {
        this.marketService.getInitialMarketList().subscribe(responses => {
            responses.forEach((pResponse, index) => {
                const pMarketLevel = this.marketLevels[index];
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        this.marketService.marketChangeListener(pEvent, this.marketIndex, this.selectedMarket).subscribe(pResponse => {
            this.selectedMarket = pResponse;
        });
    }

    saveNavigation(): void {
        const hasQueryParams = this.userCode || this.userId;
        const convertedQueryParams = `?userCode=${this.userCode}&userId=${this.userId}`;
        const baseUrl = this.location.path().split('?')[0];
        this.location.replaceState(`${baseUrl}${hasQueryParams ? convertedQueryParams : ''}`);
    }

    getSelectedLevelMarkets(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        this.marketService.getSelectedLevelMarkets(marketLevel, this.selectedMarket).subscribe(pResponse => {
            this.markets[this.marketIndex] = pResponse;
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
        });
    }

    prepareMarketFilterText(): void {
        this.selectedMarketInfo = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.selectedMarketInfo = `${this.selectedMarket[i].MarketLevel.MarketLevelName} : ${this.selectedMarket[i].MarketName}(${this.selectedMarket[i].MarketCode})`;
                break;
            }
        }
    }

    clearMapData(): void {
        this.userId = null;
        this.userCode = null;
        this.filteredTimelineList = [];
        this.timelineList = [];
        this.imeiList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.filters.userId = null;
        this.saveNavigation();
    }

    resetParameters(): void {
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.selectedMarket[i] = null;
            }
        }
        this.selectedMarketInfo = null;
    }

    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.id == pMarket2.Id;
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            UserType: this.userType,
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    setDateRange(event): void {
        const eventDate = moment(event.value);
        eventDate.set('hour', 23);
        eventDate.set('minute', 59);
        eventDate.set('second', 59);

        this.filters.date = moment(eventDate).format(SERVER_DATE_FORMAT_WITHOUT_TIME);
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    interpolatePoints(start: [number, number], end: [number, number]): [number, number][] {
        const points: [number, number][] = [];
        const totalPoints = Math.ceil((this.calculateDistance(start, end) / 40) * 0.5);
        for (let i = 1; i <= totalPoints; i++) {
            const lat = start[0] + ((end[0] - start[0]) / (totalPoints + 1)) * i;
            const long = start[1] + ((end[1] - start[1]) / (totalPoints + 1)) * i;
            points.push([lat, long]);
        }

        return points;
    }

    calculateAngle(point1: [number, number], point2: [number, number]): number {
        const lat1 = point1[0];
        const long1 = point1[1];
        const lat2 = point2[0];
        const long2 = point2[1];

        const angleRad = Math.atan2(long2 - long1, lat2 - lat1);
        const angleDeg = angleRad * (180 / Math.PI);
        return angleDeg - 90;
    }

    calculateDistance(point1: [number, number], point2: [number, number]): number {
        const [lat1, lon1] = point1;
        const [lat2, lon2] = point2;

        const toRadians = (degrees: number) => degrees * (Math.PI / 180);

        const R = 6371;
        const dLat = toRadians(lat2 - lat1);
        const dLon = toRadians(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c * 100;
    }

    getLocationList(): void {
        if (!this.filters.userId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }

        this.loadingData = true;

        this.service.getMonitorTeamTracking(this.filters, base_urls.hrws).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                this.timelineList = locationList;
                this.filteredTimelineList = locationList;
                this.lat = locationList[0].timeLinePoints[0].latitude;
                this.lng = locationList[0].timeLinePoints[0].longitude;
                this.listDataSource = locationList.map(pItem => pItem.timeLinePoints).reduce((acc, points) => acc.concat(points), []);
                this.imeiList = locationList.map(pItem => ({Imei: pItem.imei, Device: pItem.deviceName}));
            } else {
                this.timelineList = [];
                this.filteredTimelineList = [];
                this.imeiList = [];
            }
            this.prepareMapData();
        }, error => {
            this.loadingData = false;
        });
    }

    imeiChangeListener(): void {
        if (this.selectedImei) {
            this.filteredTimelineList = this.timelineList.filter(pItem => pItem.imei == this.selectedImei);
        } else {
            this.filteredTimelineList = this.timelineList;
        }
        this.prepareMapData();
        this.listDataSource = this.filteredTimelineList.map(pItem => pItem.timeLinePoints).reduce((acc, points) => acc.concat(points), []);
    }

    prepareMapData(): void {
        let timeLineInfo = [];
        let coOrdsList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.filteredTimelineList.forEach((pTimeLine, pTimeLineIndex) => {
            timeLineInfo = pTimeLine.timeLinePoints.map((
                {
                    latitude: pLatitude,
                    longitude: pLongitude,
                    fromTime: pFromTime,
                    tillTime: pTillTime,
                    address: pAddress,
                    durationInSeconds: pDurationInSeconds,
                    durationInWord: pDurationInWord
                }) => ({
                fromTime: pFromTime,
                tillTime: pTillTime,
                address: pAddress,
                durationInSeconds: pDurationInSeconds,
                durationInWord: pDurationInWord,
                coOrds: [pLatitude, pLongitude],
            }));
            const currentCoOrdsList = timeLineInfo.map(pItem => pItem.coOrds);
            coOrdsList = [...coOrdsList, ...currentCoOrdsList];
            if (coOrdsList.length > 0) {
                const bounds = L.latLngBounds(coOrdsList);
                this.map.fitBounds(bounds, {padding: [50, 50]});
            } else {
                this.map.setView([23.8383283, 90.3759853], 7);
            }
            const currentPolyline = L.polyline(currentCoOrdsList, {
                color: this.lineColors[this.selectedImei ? this.imeiList.findIndex(pImei => pImei.Imei == this.selectedImei) : pTimeLineIndex],
                weight: 15,
                opacity: 1,
                lineCap: 'round'
            });
            this.polyLineLayer.addLayer(currentPolyline);
            let customIcon = null;

            timeLineInfo.forEach((pItem, pIndex) => {
                const backgroundColor = pItem.durationInSeconds > 0 ? 'red' : 'white';
                const textColor = pItem.durationInSeconds > 0 ? 'white' : 'black';
                const borderColor = pItem.durationInSeconds > 0 ? 'white' : 'black';
                const height = pIndex < 99 ? '20px' : '25px';
                const width = pIndex < 99 ? '20px' : '25px';
                if (pIndex != 0 && pIndex < timeLineInfo.length - 1) {
                    customIcon = L.divIcon({
                        html: `<div style="text-align: center; height: ${height}; width: ${width}; font-size: 12px; padding-top: 2px; 
                                        background: ${backgroundColor}; 
                                        color: ${textColor}; 
                                        border: 1px solid ${borderColor}; 
                                        border-radius: 50%">${pIndex + 1}</div>`,
                        iconSize: pIndex < 99 ? [20, 20] : [25, 25],
                        iconAnchor: pIndex < 99 ? [10, 20] : [12.5, 25],
                        className: ''
                    });
                } else if (pIndex == 0) {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_start.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });

                } else {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_current.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });
                }

                const marker = L.marker(pItem.coOrds, {icon: customIcon})
                    .bindPopup(
                        ('<div style="font-size: 12px; font-family: Muli,serif;">' +
                            '<div>' + `${pIndex + 1}` + ') ' + `${this.datePipe.transform(pItem.fromTime, 'h:mm a')}` + ' - ' + `${this.datePipe.transform(pItem.tillTime, 'h:mm a')}` + '</div>' +
                            (pItem.address ? '<div>Address: ' + `${pItem.address}` + '</div>' : '') +
                            '<div>' + 'Duration: ' + `${pItem.durationInWord && pItem.durationInWord.trim() !== '' ? pItem.durationInWord : 'Travelling'}` + '</div>' +
                            '</div>'));
                this.markerLayerGroup.addLayer(marker);
            });
        });

        for (let i = 0; i < coOrdsList.length - 1; i++) {
            const startPoint = coOrdsList[i];
            const endPoint = coOrdsList[i + 1];
            const intermediatePoints = this.interpolatePoints(startPoint, endPoint);

            intermediatePoints.forEach((point, index) => {
                const angle = this.calculateAngle(startPoint, point);

                const icon = L.divIcon({
                    html: `<div style="transform: rotate(${angle}deg); margin: 0 5px">
                    <img src="/assets/images/arrow.svg" style="width: 10px; height: 10px;">
                 </div>`,
                    className: 'custom-icon',
                    iconSize: [10, 10]
                });

                const marker = L.marker(point, {icon: icon});
                this.markerLayerGroup.addLayer(marker);
            });
        }
        this.map.addLayer(this.polyLineLayer);
        this.map.addLayer(this.markerLayerGroup);
    }

    tabChangeListener(pTab: string): void {
        this.selectedTab = pTab;
        const map = document.getElementById('mapContainer');
        if (pTab == 'Timeline') {
            map.style.display = 'none';
        } else {
            map.style.display = 'block';
        }
    }

    downloadReport(): void {
        let isSelected: boolean;
        let isSelected1: boolean;
        let fileName: string;
        let fileType: string;
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="XLSX" id="input2" style="margin-left: 20px;"> XLSX ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (isSelected || isSelected1) {
                    swal.enableConfirmButton();
                } else {
                    swal.disableConfirmButton();
                }
                fileName = (<HTMLInputElement>document.getElementById('report')).value;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                this.filters.fileType = fileType;
                this.service.generateAsyncGetUrlForMicroservice(base_urls.hrws + Endpoints.export_monitor_user_timeline, this.filters, fileName, true).subscribe(
                    data => {
                        swal('Message', data.message, 'success');

                    });
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }

}
